import React, { useState } from 'react'
import './ticket-item.less'
import { cancelTicketApi } from '@/api/repair'
import { Toast, Modal } from 'antd-mobile'
import { withRouter } from 'react-router'
const alert = Modal.alert

function TicketItem({ info, history }: any) {
  const [item, setInfo] = useState(info)
  const statusText: any = {
    cancel: '已取消',
    wait: '待确认',
    handing: '受理中',
    assess: '待评价',
    repairing: '维修中',
  }
  //取消工单
  const requestOption = async (id: string) => {
    let params = {
      id,
    }
    Toast.loading('加载中', 0)
    const { data } = await cancelTicketApi(params)
    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 1)
      return
    }
    let ob = { ...item }
    ob.status = 'cancel'
    setInfo(ob)
  }
  //是否确定取消
  const cancelClick = async (id: string, e: any) => {
    e.stopPropagation()
    alert('是否取消工单', '', [
      { text: '否' },
      { text: '是', onPress: () => requestOption(id) },
    ])
  }
  //去评价
  const navEvaluation = (id: string, e: any) => {
    e.stopPropagation()
    history.push(`/repair/evaluation/${id}`)
  }
  return (
    <div
      className="ticket-item"
      onClick={() => history.push(`/repair/detail/${item.id}`)}
    >
      <div className="status">
        <span className="font-6">{item.parent_type_name}</span>
        <span className="font-7 color-6">{statusText[item.status]}</span>
      </div>
      <p className="font-7 color-6">{item.type_name}</p>
      <p className="font-8">{item.describe}</p>
      <p className="font-8">{item.add_time}</p>
      {item.status === 'wait' && (
        <div className="tic-oval ">
          <span onClick={(e: any) => cancelClick(item.id, e)}>取消工单</span>
        </div>
      )}
      {item.status === 'assess' && (
        <div className="tic-oval ">
          <span onClick={(e: any) => navEvaluation(item.id, e)}>评价</span>
        </div>
      )}
    </div>
  )
}

export default withRouter(TicketItem)
